module.exports = __webpack_public_path__ + "static/media/33.30941a59.mp3";